export default __webpack_public_path__ + "static/media/5.2ecc7b38.webp";